export default "__VITE_ASSET__cb768c13__"